import styled from "styled-components";
import { Box, Stack, Tooltip, LinearProgress, linearProgressClasses } from "@mui/material";
import NoDataPlaceholder from "src/components/no-data-placeholder";
import * as React from "react";
import AvatarBadge from "src/components/avatar-badge";
import timeSplitter from "src/utils/time-splitter";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === "dark" ? "#737373" : "#308fe8",
    },
}));

const Title = styled.p`
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 45px;
`;

const JobContainer = styled(Stack)`
    border: 1px solid #585858;
    border-radius: 6px;
    padding: 8px;
    white-space: nowrap;
`;

const TemplateList = ({ data, parameters }) => {
    if (!data || data.length === 0) return <NoDataPlaceholder variant="list" errorMessage={null} />;

    const calculateSumDuration = (column): number =>
        data.reduce((acc, d) => {
            return acc + (d[column.property] as number);
        }, 0);

    const meetingsPercentage = (minutesWithUser, column) =>
        (minutesWithUser / calculateSumDuration(column)) * 100;

    const renderColumn = (item, column) => {
        if (column.type === "stage-duration") {
            return (
                <Title>
                    {column.name ? `${column.name}: ` : ""}
                    {`${timeSplitter(item[column.property], "variable-accuracy")} ${timeSplitter(
                        item[column.property],
                        "text"
                    )}`}
                </Title>
            );
        }
        if (column.type === "avatar") {
            return (
                <Title style={{ display: "flex", alignItems: "center" }}>
                    <AvatarBadge
                        name={item[column.property]}
                        picture={undefined}
                        isLoading={false}
                    />
                </Title>
            );
        }
        if (column.type === "progress") {
            return (
                <BorderLinearProgress
                    variant="determinate"
                    value={meetingsPercentage(item[column.property], column)}
                />
            );
        }
        return (
            <Title>
                {column.name ? `${column.name}: ` : ""}
                {item[column.property]}
            </Title>
        );
    };
    return (
        <Box style={{ overflow: "auto", height: "100%" }}>
            <Stack direction="column" spacing={1} pr={2} style={{ width: "100%", height: "100%" }}>
                {data.map((item) => {
                    return (
                        <Tooltip
                            title={item[parameters.tooltip?.property]}
                            key={parameters.columns
                                .map((column) => item[column.property])
                                .join("-")}
                        >
                            <JobContainer direction="column">
                                <Stack direction="row" spacing={1} justifyContent="space-between">
                                    {parameters.columns.map((column) => {
                                        if (column.type === "composite") {
                                            return (
                                                <Stack
                                                    direction="column"
                                                    pl={2}
                                                    style={{ width: "220px" }}
                                                >
                                                    {column.parts.map((part) =>
                                                        renderColumn(item, part)
                                                    )}
                                                </Stack>
                                            );
                                        }
                                        return renderColumn(item, column);
                                    })}
                                </Stack>
                            </JobContainer>
                        </Tooltip>
                    );
                })}
            </Stack>
        </Box>
    );
};

export default TemplateList;
